import messages from "@intlify/unplugin-vue-i18n/messages";
import { createI18n } from "vue-i18n";

export const i18n: any = createI18n({
	locale: import.meta.env.VITE_APP_I18N_LOCALE || "en",
	fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || "en",
	legacy: false,
	messages,
});

export function changeLanguage(locale: "fr" | "en") {
	i18n.global.locale = locale;
}

export function $t(key: string);
export function $t(key: string, multiCount: number | Record<string, string>);
export function $t(
	key: string,
	multiCount: Record<string, string>,
	values: number,
);
export function $t(
	key = "",
	values: Record<string, string> = null,
	multiCount: number = 0,
) {
	if (!values && !multiCount) {
		return i18n.global.t(key);
	}
	if (!values) {
		return i18n.global.t(key, multiCount);
	}
	return i18n.global.t(key, values, multiCount);
}
